// components/MyPage/CombinedHistory.jsx
import { Tabs, Tab, Box, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import CasinoIcon from '@mui/icons-material/Casino';        // 뽑기
import PaidIcon from '@mui/icons-material/Paid';          // 포인트
import InventoryIcon from '@mui/icons-material/Inventory2';    // 아이템
import ReportIcon from '@mui/icons-material/ReportProblem'; // ⭐ 신고

import GachaHistory from '../Gacha/GachaHistory';
import MyPointHistory from './MyPointHistory';
import MyItemHistory from './MyItemHistory';
import MyReports from './MyReports';      // ⭐ 추가

/* 탭 인덱스
   0: 뽑기   1: 포인트   2: 아이템   3: 신고 */
export default function CombinedHistory() {
    const [tab, setTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ width: '100%' }}>
            {/* ⓐ 탭 바 */}
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant={isMobile ? 'fullWidth' : 'scrollable'}
                scrollButtons={isMobile ? false : 'auto'}
                aria-label="history tabs"
                sx={{ mb: 1 }}
                centered={isMobile}
            >
                <Tab icon={<CasinoIcon fontSize="small" />} label={isMobile ? '' : '뽑기'} sx={{ minWidth: 60 }} />
                <Tab icon={<PaidIcon fontSize="small" />} label={isMobile ? '' : '포인트'} sx={{ minWidth: 60 }} />
                <Tab icon={<InventoryIcon fontSize="small" />} label={isMobile ? '' : '아이템'} sx={{ minWidth: 60 }} />
                <Tab icon={<ReportIcon fontSize="small" />} label={isMobile ? '' : '신고'} sx={{ minWidth: 60 }} />
            </Tabs>

            {/* ⓑ 탭 패널 */}
            <Box sx={{ mt: 1 }}>
                {tab === 0 && <GachaHistory />}
                {tab === 1 && <MyPointHistory />}
                {tab === 2 && <MyItemHistory />}
                {tab === 3 && <MyReports />}   {/* ⭐ 추가 */}
            </Box>
        </Box>
    );
}